/**
 * 题目配图的最后一道闸:后端 figures.py 已经白名单清洗过,这里再挡一次
 * (脚本、事件属性、外链、嵌入),不通过就当没有图。SVG 是模型生成的,
 * 一律按不可信内容对待 —— 只允许纯几何/文本绘制。
 */
const FORBIDDEN_TAG = /<\s*\/?\s*(script|foreignObject|image|iframe|object|embed|use|link|style)\b/i;
const EVENT_ATTR = /\son[a-z]+\s*=/i;
const EXTERNAL = /(?:href|src)\s*=/i;

export function safeSvg(raw: string | null | undefined): string | null {
  if (!raw) return null;
  const m = /<svg\b[\s\S]*?<\/svg>/i.exec(raw);
  if (!m) return null;
  const svg = m[0];
  if (svg.length > 60_000) return null;
  if (FORBIDDEN_TAG.test(svg) || EVENT_ATTR.test(svg) || EXTERNAL.test(svg)) return null;
  return svg;
}

/** 打印单里的配图块:居中、随页宽缩放、带「图N」小字。 */
export function figureHtml(svg: string, caption: string): string {
  return `<figure class="fig">${svg}<figcaption>${caption}</figcaption></figure>`;
}

export const FIGURE_CSS = `
  .fig { margin: 8px 0 4px; text-align: center; page-break-inside: avoid; break-inside: avoid; }
  .fig svg { max-width: 100%; height: auto; }
  .fig figcaption { font-size: 12px; color: #64748b; margin-top: 2px; }`;
